import { tv } from "@ui/lib/tv";
import { Link } from "@ui/primitives/Link";
import type { ReactNode } from "react";

const cardAuthor = tv({
  slots: {
    root: "flex items-center gap-2",
    name: "line-clamp-1 text-base font-medium leading-6 text-neutral-900",
  },
  variants: {
    link: {
      // Raised above the card's absolute overlay link so the author stays clickable.
      true: { root: "relative z-10 no-underline" },
    },
  },
});

export interface CardAuthorProps {
  avatar: ReactNode;
  className?: string;
  /** When set, the row renders as a link raised above the card's overlay link. */
  href?: string;
  name: string;
}

export function CardAuthor({ avatar, className, href, name }: CardAuthorProps) {
  const styles = cardAuthor({ link: href != null });
  const content = (
    <>
      {avatar}
      <span className={styles.name()}>{name}</span>
    </>
  );

  if (href != null) {
    return (
      <Link className={styles.root({ className })} href={href}>
        {content}
      </Link>
    );
  }

  return <div className={styles.root({ className })}>{content}</div>;
}
